import { Modal } from 'react-bootstrap';
import { Card, Button, Input, DatePicker, Dropdown, Row } from 'components';
import { AiFillCloseCircle } from 'react-icons/ai';

const AddContestPrizeModal = ({ _this }) => {
  return (
    <Modal
      show={_this.addContestPrizeModal}
      onHide={() => _this.setAddContestPrizeModal(false)}
      fullscreen="lg-down"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">Add Contest Prize</Modal.Title>
        <AiFillCloseCircle size={30} onClick={() => _this.setAddContestPrizeModal(false)} />
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Dropdown
            label="Location"
            className="w-48 z-10"
            placeholder="@location"
            required
            type="text"
            options={_this.locationList}
            aria-label="Default select example"
            value={_this.addContestPrizeData?.location_group}
            onChange={(e) => {
              _this.setAddContestPrizeData((prev) => ({
                ...prev,
                location_group: e
              }));
            }}
          />
          <Dropdown
            label="Category"
            className="w-48 z-8"
            placeholder="@tier"
            required
            type="text"
            options={[
              { label: 'Tier 1', value: 'tier_1' },
              { label: 'Tier 2', value: 'tier_2' }
            ]}
            aria-label="Default select example"
            value={_this.addContestPrizeData?.category}
            onChange={(e) => {
              _this.setAddContestPrizeData((prev) => ({
                ...prev,
                category: e
              }));
            }}
          />
        </Row>
        <Row>
          <Input
            type="text"
            placeholder="Enter hurdle value..."
            label="Hurdle Value"
            required
            value={_this.addContestPrizeData?.hurdle_value}
            onChange={(e) => {
              _this.setAddContestPrizeData((prev) => ({
                ...prev,
                hurdle_value: e.target.value
              }));
            }}
          />
          <Input
            type="text"
            placeholder="Enter Multiple..."
            label="Multiple"
            required
            value={_this.addContestPrizeData?.multiple}
            onChange={(e) => {
              _this.setAddContestPrizeData((prev) => ({
                ...prev,
                multiple: e.target.value
              }));
            }}
          />
        </Row>
        <Row>
          <Input
            type="text"
            placeholder="Enter Actual Prize..."
            label="Actual Prize"
            required
            value={_this.addContestPrizeData?.actual_prize}
            onChange={(e) => {
              _this.setAddContestPrizeData((prev) => ({
                ...prev,
                actual_prize: e.target.value
              }));
            }}
          />
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => {
            _this.addContestPrize();
          }}
        >
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddContestPrizeModal;
